<template>
  <div v-if="authenticatedUser">
    <b-container>
      <div class="mt-5 pl-3 pr-3 pb-3 bg-white">
        <b-row class="pl-3 pr-3 pt-4">
          <h3 class="text-left">Register a new recipe</h3>
        </b-row>
        <hr />
        <b-row>
          <b-col class="my-container" cols-6>
            <b-form>
              <b-form-group
                id="input-group-1"
                label-align="left"
                label-for="input-1"
              >
                <label class="d-block text-left text-bold"
                  >Recipe title <span class="text-danger">*</span></label
                >
                <b-form-input placeholder="Enter a title" v-model="title">
                </b-form-input>

                <b-alert
                  dismissible
                  style="width: 100%"
                  v-model="emptyTitleAlert"
                  variant="danger"
                >
                  You have to provide a title!
                </b-alert>
              </b-form-group>

              <b-form-group>
                <label class="d-block text-left text-bold"
                  >Description <span class="text-danger">*</span></label
                >
                <textarea
                  class="col-12 form-control textareaDescription"
                  placeholder="Enter a description"
                  v-model="description"
                >
                </textarea>

                <b-alert
                  dismissible
                  style="width: 100%"
                  v-model="emptyDescriptionAlert"
                  variant="danger"
                >
                  You have to provide a description!
                </b-alert>
              </b-form-group>

              <b-form-group class="text-left">
                <label
                  title="Link to a website presenting the project"
                  v-b-tooltip.hover.bottom
                  >URL</label
                >
                <b-form-input
                  placeholder="Link to a website presenting the project"
                  v-model="url"
                >
                </b-form-input>
              </b-form-group>

              <b-form-group class="text-left">
                <label
                  title="Some keywords that capture important aspects of the recipe"
                  v-b-tooltip.hover.bottom
                  >Keywords</label
                >
                <tags-input
                  :typeahead="true"
                  element-id="keywords"
                  placeholder="  Some keywords that capture important aspects of the recipe"
                  v-model="keywords"
                >
                </tags-input>
                <p
                  class="text-left font-italic"
                  style="color: red; font-size: 14px"
                >
                  * Press Enter after each keyword.
                </p>
              </b-form-group>

              <!--              <b-form-group class="text-left">-->
              <!--                <label-->
              <!--                  title="Services and facilities that this organisation offers and can be useful for the organisation of participatory projects, e.g. meeting rooms, 3D printer etc"-->
              <!--                  v-b-tooltip.hover.bottom>Services</label>-->
              <!--                <b-form-textarea-->
              <!--                  class="col-12 form-control"-->
              <!--                  placeholder="Services and facilities that this organisation offers and can be useful for the organisation of participatory projects, e.g. meeting rooms, 3D printer etc"-->
              <!--                  style="height: 90px"-->
              <!--                  v-model="services">-->
              <!--                </b-form-textarea>-->
              <!--              </b-form-group>-->

              <b-form-group class="text-left">
                <label
                  title="Pieces of practical advice, especially on matters whose importance is often not anticipated in advance"
                  v-b-tooltip.hover.bottom
                  >Tips
                </label>
                <b-form-textarea
                  class="col-12 form-control"
                  placeholder="Pieces of practical advice, especially on matters whose importance is often not anticipated in advance"
                  style="height: 130px"
                  v-model="tips"
                >
                </b-form-textarea>
              </b-form-group>
            </b-form>
          </b-col>

          <b-col cols-6>
            <b-form>
              <b-form-group class="text-left">
                <label
                  title="How long the execution of the recipe took/is expected to take in real time"
                  v-b-tooltip.hover.bottom
                  >Duration</label
                >
                <b-form-select :options="Duration" v-model="duration">
                </b-form-select>
              </b-form-group>

              <b-form-group class="text-left">
                <label
                  title="Number of participants addressed by the recipe"
                  v-b-tooltip.hover.bottom
                  >Number of participants</label
                >
                <b-form-select
                  :options="NumberOfParticipants"
                  v-model="numberOfParticipants"
                >
                </b-form-select>
              </b-form-group>

              <b-form-group class="text-left">
                <label
                  title="Cost for organising the recipe"
                  v-b-tooltip.hover.bottom
                  >Cost</label
                >
                <b-form-select :options="Cost" v-model="cost"> </b-form-select>
              </b-form-group>

              <b-container class="my-container">
                <b-form-group>
                  <label class="d-block text-left text-bold"                    
                      >
                      <span title="Topics addressed by the project"
                    v-b-tooltip.hover.bottom>Areas of Focus</span>
                       <span class="text-danger">*</span> (Hold
                      <strong>Ctrl</strong> to select multiple values)</label
                    >
                  <b-row>
                    <b-col class="col-12">
                      <b-form-select
                        :options="FocusAreaOptions"
                        :select-size="11"
                        multiple
                        v-model="selectedFocusAreas"
                      >
                      </b-form-select>
                      <b-form-group
                        class="mt-4"
                        v-if="this.selectedFocusAreas.includes('Other')"
                      >
                        <label class="d-block text-left text-bold"
                          >Please specify</label
                        >
                        <b-form-input
                          placeholder="Enter the focus area of the recipe"
                          v-model="additionalFocusArea"
                        >
                        </b-form-input>
                      </b-form-group>
                    </b-col>

                    <!--                    <b-col class="col-6">-->
                    <!--                      <b-form-checkbox-group-->
                    <!--                        :options="FocusAreaOptions2"-->
                    <!--                        v-model="selectedFocusAreas2">-->
                    <!--                      </b-form-checkbox-group>-->
                    <!--                    </b-col>-->
                  </b-row>
                </b-form-group>

                <b-alert
                  dismissible
                  style="width: 100%"
                  v-model="emptySelectedFocusAreas1Alert"
                  variant="danger"
                >
                  You have to provide at least one focus area!
                </b-alert>
              </b-container>

              <br />
              <br />

              <b-container>
                <b-row>
                  <b-col cols="5">
                    <b-form-checkbox
                      align-self="left"
                      checked-value="true"
                      class="custom-control"
                      style="margin-left: -30px"
                      title="Everybody can see"
                      unchecked-value="false"
                      v-b-tooltip.hover.bottom
                      v-model="publicReadable"
                    >
                      Public
                    </b-form-checkbox>
                  </b-col>

                  <b-col cols="5">
                    <b-form-checkbox
                      align-self="start"
                      checked-value="true"
                      class="custom-control"
                      title="Whether the recipe describes a past completed project or is about a new or ongoing project idea"
                      unchecked-value="false"
                      v-b-tooltip.hover.bottom
                      v-model="implemented"
                    >
                      Completed
                    </b-form-checkbox>
                  </b-col>
                </b-row>
              </b-container>
            </b-form>
          </b-col>
        </b-row>

        <hr />

        <b-row>
          <b-col class="text-left" cols="12">
            <label 
              title="Upload a file that will appear as the recipe’s banner upon presentation. Providing this visual material will make your recipe more appealing."
                      v-b-tooltip.hover.bottom
              ><strong>Recipe banner</strong></label>
            <!--            <button @click="choseNew" class="btn bg-orange btn-sm">Upload new image</button>-->
            <!--            <button @click="choseExisting" class="btn bg-orange btn-sm">Choose existing image</button>-->
          </b-col>
        </b-row>

        <b-row class="mt-2 mb-2" v-show="chooseExisting">
          <b-col cols="6">
            <b-form-group>
              <b-form-input
                @click="searchImage"
                placeholder="Search for an image"
                v-model="chosenImageId"
              >
              </b-form-input>
            </b-form-group>
          </b-col>
        </b-row>

        <b-row class="mt-2 mb-2" v-show="!chooseExisting">
          <b-col cols="6">
            <!-- add content  -->
            <b-form-group>
              <b-form-file
                :state="Boolean(file)"
                class="text-left"
                drop-placeholder="Drop file here..."
                placeholder="Browse your files..."
                v-model="file"
              >
              </b-form-file>
            </b-form-group>
          </b-col>
        </b-row>

        <hr />

        <b-row>
          <b-col cols-12>
            <b-form>
              <b-row class="p-3">
                <p><strong>Languages & Countries</strong></p>
              </b-row>
              <b-row>
                <b-col class="text-left" cols="1">
                  <label
                    class="text-left"
                    title="Languages used for communication within the recipe"
                    v-b-tooltip.hover.bottom
                  >
                    Languages
                  </label>
                </b-col>
                <b-col cols="4">
                  <label class="text-left"
                    >Hold <strong>Ctrl</strong> to select multiple</label
                  >
                  <b-form-group label-align="left" label-for="input-24">
                    <b-form-select
                      :options="TargetGroupLanguage"
                      multiple
                      :select-size="10"
                      v-model="languages"
                    >
                    </b-form-select>
                  </b-form-group>
                  <b-form-group class="mt-4" v-if="languages.includes('Other')">
                    <label class="d-block text-left text-bold"
                      >Please specify</label
                    >
                    <b-form-input
                      placeholder="Enter the additional language"
                      v-model="additionalLanguage"
                    >
                    </b-form-input>
                  </b-form-group>
                </b-col>
                <b-col class="text-left" cols="1">
                  <label
                    class="text-left"
                    title="Countries in which the recipe took/takes/will take place"
                    v-b-tooltip.hover.bottom
                  >
                    Countries
                  </label>
                </b-col>
                <b-col cols="4">
                  <label class="text-left"
                    >Hold <strong>Ctrl</strong> to select multiple</label
                  >
                  <b-form-group label-align="left" label-for="input-24">
                    <b-form-select
                      :options="TargetGroupCountry"
                      multiple
                      :select-size="10"
                      v-model="countries"
                    >
                    </b-form-select>
                  </b-form-group>
                  <b-form-group class="mt-4" v-if="countries.includes('Other')">
                    <label class="d-block text-left text-bold"
                      >Please specify</label
                    >
                    <b-form-input
                      placeholder="Enter the additional country"
                      v-model="additionalCountry"
                    >
                    </b-form-input>
                  </b-form-group>
                </b-col>
              </b-row>
            </b-form>
          </b-col>
        </b-row>

        <hr />

        <b-row>
          <b-col cols-12>
            <b-form>
              <!-- target groups -->
              <b-row class="p-3">
                <p>
                  <span class="col-3 mr-5">
                    <strong
                      title="The main target groups and beneficiaries of the recipe"
                      v-b-tooltip.hover.bottom
                    >
                      Target Groups
                    </strong>
                  </span>
                  <span class="col-8">
                    <a
                      @click.prevent="addNewTargetGroupForm"
                      class="text-orange"
                      href="#"
                      >Add new Target group</a
                    >
                  </span>
                </p>
              </b-row>
              <b-row>
                <b-col cols-4>
                  <div
                    :key="index"
                    class="row my-container"
                    v-for="(TG, index) in targetGroup"
                  >
                    <b-col class="text-left" cols="2">
                      <label class="text-left"
                        >Target group {{ index + 1 }}
                      </label>
                    </b-col>
                    <b-col cols="4">
                      <b-form-group>
                        <label class="d-block text-left text-bold"
                          >Target group type<span class="text-danger">*</span>
                          (Hold <strong>Ctrl</strong> to select multiple)</label
                        >
                        <b-form-select
                          :options="TargetGroupTypes"
                          multiple
                          :select-size="10"
                          title="Please select the type(s) that better describe your target group"
                          v-b-tooltip.hover.bottom
                          v-model="TG.type"
                        >
                        </b-form-select>
                      </b-form-group>
                      <b-form-group
                        class="mt-4"
                        v-if="targetGroup[index].type.includes('Other')"
                      >
                        <label class="d-block text-left text-bold"
                          >Please specify</label
                        >
                        <b-form-input
                          placeholder="Enter the additional target group"
                          v-model="additionalTargetGroup[index]"
                        >
                        </b-form-input>
                      </b-form-group>
                    </b-col>
                    <b-col cols="4">
                      <b-form-group label-align="left" label-for="input-24">
                        <textarea
                          class="col-12 form-control"
                          placeholder="Enter description"
                          style="height: 100px; margin-top: 32px"
                          title="Describe the target groups of the recipe"
                          v-b-tooltip.hover.bottom
                          v-model="TG.description"
                        >
                        </textarea>
                      </b-form-group>
                    </b-col>
                    <b-col class="mt-5" cols="1">
                      <span
                        @click="deleteTargetGroup(index)"
                        class="col-1 float-body"
                        style="cursor: pointer; color: red"
                        title="Delete"
                      >
                        <font-awesome-icon icon="trash-alt" />
                      </span>
                    </b-col>
                  </div>
                </b-col>
              </b-row>
              <hr />
              <!-- steps -->
              <b-row class="p-3">
                <p>
                  <span class="col-3 mr-5"
                    ><strong
                      title="Activities that took/take/will take place as part of the recipe"
                      v-b-tooltip.hover.bottom
                      >Steps</strong
                    ></span
                  >
                  <span class="col-8">
                    <a
                      @click.prevent="addNewStepForm"
                      class="text-orange"
                      href="#"
                      >Add new step</a
                    >
                  </span>
                </p>
              </b-row>
              <b-row class="p-3">
                <b-col cols-12>
                  <div
                    :key="index"
                    class="col-12 row my-container"
                    v-for="(step, index) in steps"
                  >
                    <b-row class="col-12 my-container">
                      <label>Step {{ index + 1 }} </label>
                      <b-form-group class="col-4">
                        <b-form-input
                          placeholder="Enter step title"
                          v-model="step.title"
                        />
                      </b-form-group>
                      <b-form-group class="col-4">
                        <textarea
                          class="col-12 form-control"
                          placeholder="Enter step description"
                          v-model="step.description"
                        />
                      </b-form-group>

                      <span
                        class="col-1 float-body"
                        title="Add step underneath"
                        v-b-tooltip.hover.top
                      >
                        <font-awesome-icon
                          style="color: green; cursor: pointer"
                          @click="addNewStepUnderneath(index)"
                          icon="plus"
                        />
                      </span>
                      <span
                        class="col-1 float-body"
                        title="Delete step"
                        v-b-tooltip.hover.top
                      >
                        <font-awesome-icon
                          style="color: red; cursor: pointer"
                          @click="deleteStep(index)"
                          icon="trash-alt"
                        />
                      </span>
                    </b-row>
                    <br />
                  </div>
                </b-col>
              </b-row>
              <hr />
              <!-- challenges -->
              <b-row class="p-3">
                <p>
                  <span class="col-3 mr-5">
                    <strong
                      title="Main challenge encountered (or foreseen to encounter) and description of possible ways to address them, including helpful resources"
                      v-b-tooltip.hover.bottom
                      >Challenges
                    </strong>
                  </span>
                  <span class="col-8">
                    <a
                      @click.prevent="addNewChallengeForm"
                      class="text-orange"
                      href="#"
                      >Add new challenge</a
                    >
                  </span>
                </p>
              </b-row>
              <b-row class="p-3">
                <b-col cols-12>
                  <div
                    :key="index"
                    class="row my-container"
                    v-for="(challenge, index) in challenges"
                  >
                    <b-row class="col-12 my-container">
                      <label>Challenge {{ index + 1 }} </label>
                      <b-form-group class="col-4">
                        <textarea
                          class="col-12 form-control"
                          placeholder="Briefly describe the challenge"
                          rows="2"
                          style="height: 120px"
                          v-model="challenge.description"
                        />
                      </b-form-group>

                      <b-form-group class="col-4">
                        <textarea
                          class="col-12 form-control"
                          placeholder="Briefly describe a way to address it"
                          rows="2"
                          style="height: 120px"
                          v-model="challenge.solution"
                        />
                      </b-form-group>

                      <span
                        @click="deleteChallenge(index)"
                        class="col-1 float-body"
                        style="cursor: pointer; color: red"
                        title="Delete"
                      >
                        <font-awesome-icon icon="trash-alt"
                      /></span>
                    </b-row>

                    <!--                    <b-row class="col-12 my-container">-->
                    <!--                      <label class="col-5 mt-1">Choose an ingredient to resolve the challenge:</label>-->
                    <!--                      <b-form-group class="col-4" label-align="left"-->
                    <!--                                    label-for="input-100">-->
                    <!--                        <b-form-input-->
                    <!--                          style="border: solid #e24a1f"-->
                    <!--                          @click="searchChallenge(index)"-->
                    <!--                          label-align="left"-->
                    <!--                          placeholder="Search ingredient"-->
                    <!--                          type="text"-->
                    <!--                          v-model="chosenChallengeName[index]"-->
                    <!--                        />-->
                    <!--                      </b-form-group>-->
                    <!--                    </b-row>-->

                    <br />
                  </div>
                </b-col>
              </b-row>
              <hr />
              <!-- Collaborators -->
              <b-row class="text-left p-3">
                <p>
                  <span
                    class="text-left col-3 mr-5"
                    title="The organisations that collaborated/need to collaborate for the implementation of the recipe."
                    v-b-tooltip.hover.bottom
                    ><strong>Collaborators</strong>
                  </span>
                </p>
                <p class="text-left container pl-3 font-italic">
                  You can either (a) search for an existing organisation and add
                  it as a collaborator for this recipe or (b) register a new
                  organisation or (c) just add the description of a collaborator
                  as part of the recipe description.
                </p>
              </b-row>
              <b-row class="pl-4">
                <div class="col-12 row my-container">
                  <b-row>
                    <b-col class="text-left" cols="5">
                      <p>
                        <strong
                          >(a) Search for an existing organisation and add it as
                          a collaborator for this recipe</strong
                        >
                      </p>
                    </b-col>
                    or
                    <b-col class="text-left" cols="3">
                      <p>
                        <strong
                          >(b) Register a new organisation and add it as a
                          collaborator</strong
                        >
                      </p>
                    </b-col>
                    <b-col class="text-left ml-5" cols="3">
                      <b-button
                        @click="addNewCollaboratorForm"
                        class="btn bg-orange btn-sm"
                      >
                        <span
                          style="cursor: pointer; color: green"
                          title="Add new"
                        >
                          <font-awesome-icon icon="plus" />
                        </span>
                        Add new collaborator
                      </b-button>
                    </b-col>
                  </b-row>
                  <div
                    :key="index"
                    class="col-12 row my-container"
                    v-for="(collaborator, index) in collaboratorsWithId"
                  >
                    <label>Collaborator {{ index + 1 }}</label>
                    <b-form-group class="CollaboratorsAlign">
                      <b-form-input
                        @click="searchOrganisation(index)"
                        placeholder="Search collaborator"
                        title="You may search for an existing registered organisation"
                        type="text"
                        v-b-tooltip.hover.bottom
                        v-model="chosenCollaboratorName[index]"
                      >
                      </b-form-input>
                    </b-form-group>

                    <span>
                      <b-button
                        @click="modalOrgShow = !modalOrgShow"
                        class="btn bg-orange btn-sm"
                        style="
                          cursor: pointer;
                          margin-left: 65px;
                          margin-bottom: 0px;
                          color: red;
                        "
                        title="Register a new organisation to add it as a collaborator"
                        v-b-tooltip.hover.bottom
                        v-show="!chosenCollaboratorName[index]"
                      >
                        ... or create a new organisation
                      </b-button>
                      <b-modal
                        hide-footer
                        size="xl"
                        static
                        v-model="modalOrgShow"
                        ><CreateNewOrganization></CreateNewOrganization
                      ></b-modal>
                    </span>
                    <span
                      @click="deleteCollaborator(index)"
                      style="
                        cursor: pointer;
                        margin-left: 45px;
                        margin-bottom: 0px;
                        color: red;
                      "
                      title="Delete"
                    >
                      <font-awesome-icon icon="trash-alt" />
                    </span>
                    <!--                    <span-->
                    <!--                      @click="addNewCollaboratorForm"-->
                    <!--                      style="cursor:pointer; color: green;"-->
                    <!--                      class="ml-3"-->
                    <!--                      title="Add new">-->
                    <!--                      <font-awesome-icon icon="plus"/>-->
                    <!--                    </span>-->
                  </div>
                </div>
              </b-row>

              <b-row class="mt-4 pl-2">
                <div class="col-12 row my-container">
                  <b-col class="text-left" cols="9">
                    <p>
                      <strong
                        >(c) Add the description of a collaborator as part of
                        the recipe description (no need to register it as an
                        organisation in the platform)</strong
                      >
                    </p>
                  </b-col>
                  <b-col class="text-left" cols="2">
                    <b-button
                      @click="addNewNonExistingCollaborator"
                      class="btn bg-orange btn-sm"
                    >
                      <span
                        style="cursor: pointer; color: green"
                        title="Add new"
                      >
                        <font-awesome-icon icon="plus" />
                      </span>
                      Add new
                    </b-button>
                    <!--                      <p class="pl-3"><a @click.prevent="addNewNonExistingCollaborator" class="text-orange" href="#">Add-->
                    <!--                      new</a></p>-->
                  </b-col>
                  <b-row
                    :key="index"
                    class="mt-3 col-12"
                    v-for="(collaborator, index) in collaborators"
                  >
                    <label
                      class="pl-3"
                      title="This collaborator is not going to be registered in the platform"
                      v-b-tooltip.hover.bottom
                      >{{ index + 1 }})
                    </label>
                    <b-col>
                      <b-form-input
                        placeholder="Enter the collaborator's name"
                        v-model="collaborators[index].name"
                      >
                      </b-form-input>
                      <select
                        class="mt-2 custom-select d-block w-100"
                        id="CollaboratorType"
                        v-model="collaborators[index].type"
                      >
                        <option disabled value="">Select type</option>
                        <option value="Central government">
                          Central government
                        </option>
                        <option value="Charity or foundation">
                          Charity or foundation
                        </option>
                        <option value="For-profit organisation">
                          For-profit organisation
                        </option>
                        <option value="GLAM">
                          GLAM (Galleries, Libraries, Archives, Museums)
                        </option>
                        <option value="Informal group or association">
                          Informal group or association
                        </option>
                        <option value="International body">
                          International body
                        </option>
                        <option value="Local government">
                          Local government
                        </option>
                        <option value="Non-Governmental Organisation">
                          Non-Governmental Organisation
                        </option>
                        <option value="Regional government">
                          Regional government
                        </option>
                        <option value="Religious institutions">
                          Religious institutions
                        </option>
                        <option value="School">School</option>
                        <option value="University or research institute">
                          University or research institute
                        </option>
                        <option value="Other">Other</option>
                      </select>
                    </b-col>
                    <b-col>
                      <b-textarea
                        placeholder="Enter the collaborator's description"
                        style="height: 84px"
                        v-model="collaborators[index].description"
                      >
                      </b-textarea>
                    </b-col>
                    <span class="mt-4">
                      <span
                        @click="deleteNonExistingCollaborator(index)"
                        class="ml-2"
                        style="cursor: pointer; color: red"
                        title="Delete"
                      >
                        <font-awesome-icon icon="trash-alt" />
                      </span>
                    </span>
                  </b-row>
                </div>
              </b-row>

              <hr />

              <!-- ingredients/recipes -->
              <!--              <p class="text-left">-->
              <!--                <strong-->
              <!--                  title="Resources in different formats (images, documents, links to videos or websites) that are useful for the organisation of a project, e.g. training material, policies, past projects, digital cultural heritage objects, etc. You can either search to add existing resources as ingredients to this recipe or create new ones"-->
              <!--                  v-b-tooltip.hover.bottom>-->
              <!--                  Ingredients-->
              <!--                </strong>-->
              <!--              </p>-->
              <!--              <b-row class="p-3">-->
              <!--                <p>-->
              <!--                  <span class="col-3 mr-5"><strong>Recipes</strong></span>-->
              <!--                  <span class="col-8">-->
              <!--                  <a @click.prevent="addNewRecipeForm" class="text-orange" href="#">Add new recipe as ingredient</a>-->
              <!--                </span>-->
              <!--                </p>-->
              <!--              </b-row>-->
              <!--              <b-row class="p-3">-->
              <!--                <b-col cols-12>-->
              <!--                  <div :key="index" class="row my-container" v-for="(recipe,index)  in recipes">-->
              <!--                    <b-row class="col-12 my-container">-->
              <!--                      <label>Recipe {{index +1}}</label>-->
              <!--                      <b-form-group class="col-4">-->
              <!--                        <b-form-input-->
              <!--                          @click="searchIngredientRecipe(index)"-->
              <!--                          class="col-12 form-control"-->
              <!--                          placeholder="Search recipe"-->
              <!--                          type="text"-->
              <!--                          v-model="chosenIngRecipeName[index]"-->
              <!--                        />-->
              <!--                      </b-form-group>-->

              <!--                      <span-->
              <!--                        @click="deleteRecipe(index)"-->
              <!--                        class="col-1 float-body"-->
              <!--                        style="cursor:pointer; color: red;"-->
              <!--                        title="Delete">-->
              <!--                      <font-awesome-icon icon="trash-alt"/></span>-->
              <!--                    </b-row>-->
              <!--                  </div>-->
              <!--                </b-col>-->
              <!--              </b-row>-->
              <!--              <hr>-->
              <!-- ingredients/resources -->
              <b-row class="p-3">
                <p>
                  <span class="col-3 mr-5">
                    <strong
                      title="Resources in different formats (images, documents, links to videos or websites) that are useful for the organisation of a project, e.g. training material, policies, past projects, digital cultural heritage objects, etc. You can either search to add existing resources as ingredients to this recipe or create new ones"
                      v-b-tooltip.hover.bottom
                    >
                      Ingredients
                    </strong>
                  </span>
                  <span class="col-8">
                    <a
                      @click.prevent="addNewResourceForm"
                      class="text-orange"
                      href="#"
                      >Add new ingredient</a
                    >
                  </span>
                </p>
              </b-row>
              <b-row class="p-3">
                <b-col cols-12>
                  <div
                    :key="index"
                    class="row my-container"
                    v-for="(resource, index) in resources"
                  >
                    <b-row class="col-12 my-container">
                      <label>Ingredient {{ index + 1 }}</label>
                      <b-form-group class="col-4">
                        <b-form-input
                          @click="searchIngredientResource(index)"
                          class="col-12 form-control"
                          placeholder="Search ingredient"
                          type="text"
                          v-model="chosenIngResourceName[index]"
                        />
                      </b-form-group>
                      <span
                        @click="deleteResource(index)"
                        class="col-1 float-body"
                        style="cursor: pointer; color: red"
                        title="Delete"
                      >
                        <font-awesome-icon icon="trash-alt" />
                      </span>
                      <span>
                        <b-button
                          @click="modalResShow = !modalResShow"
                          class="btn bg-orange btn-sm"
                          title="Create new ingredient"
                          v-show="!chosenIngResourcesArray[index]"
                        >
                          Create new ingredient
                        </b-button>
                        <b-modal hide-footer size="xl" v-model="modalResShow"
                          ><CreateNewResource></CreateNewResource
                        ></b-modal>
                      </span>
                    </b-row>
                  </div>
                </b-col>
              </b-row>

              <hr />

              <b-row class="p-3">
                <p>
                  <span class="col-3 mr-5">
                    <strong
                      title="Resources describing the results of the described project (e.g. photographs from events, links to digital exhibitions, evaluation reports,  etc). You can either search to add existing resources from the ingredients repository as outputs of this recipe or create new ones"
                      v-b-tooltip.hover.bottom
                      >Outputs
                    </strong>
                  </span>
                  <span class="col-8">
                    <a
                      @click.prevent="addNewOutputsForm"
                      class="text-orange"
                      href="#"
                      >Add new output</a
                    >
                  </span>
                </p>
              </b-row>
              <b-row class="p-3">
                <b-col cols-12>
                  <div
                    :key="index"
                    class="col-12 row my-container"
                    v-for="(output, index) in outputs"
                  >
                    <b-row class="col-12 my-container">
                      <label>Output {{ index + 1 }} </label>
                      <b-form-group
                        class="widthTextAreaOutputs"
                        label-for="input-1"
                      >
                        <b-form-input
                          @click="searchOutputs(index)"
                          placeholder="Search for existing ingredients to add as relevant output"
                          style="width: 100%"
                          type="text"
                          v-model="chosenOutputsName[index]"
                        />
                      </b-form-group>

                      <a
                        @click.prevent="deleteOutputs(index)"
                        class="ml-4 text-danger"
                        href="#"
                        title="Delete"
                      >
                        <font-awesome-icon icon="trash-alt" size="1x" />
                      </a>
                    </b-row>
                  </div>
                </b-col>
              </b-row>
            </b-form>
          </b-col>
        </b-row>

        <hr />

        <div class="center">
          <!--General info Title-->
          <!-- Save -->
          <b-row>
            <b-alert
              dismissible
              style="width: 100%"
              v-model="showDismissibleAlert"
              variant="danger"
            >
              You must fill in all the required fields!
            </b-alert>
          </b-row>
          <b-row class="p-3 mb-4">
            <div>
              <router-link :to="{ name: 'recipes' }">
                <b-button class="link">Cancel</b-button>
              </router-link>
              <button
                @click="checkForm"
                class="btn bg-orange"
                style="margin: 0"
                type="button"
              >
                Save
              </button>
            </div>
          </b-row>
        </div>
      </div>
    </b-container>
  </div>
  <div v-else>
    <NoAccess></NoAccess>
  </div>
</template>

<script>
import CreateNewResource from "../components/resources/CreateNewResource";
import NoAccess from "../components/NoAccess";
import CreateNewOrganization from "../components/organizations/CreateNewOrganization";
import SearchPlugin from "../plugins/SearchPlugin";
import { mapGetters } from "vuex";
import { eventBus } from "../main";

export default {
  data() {
    return {
      chooseExisting: false,
      file: null,
      saveAction: false,

      // Open modal for new resource handler
      modalResShow: false,

      // Open modal for new organisation handler
      modalOrgShow: false,

      // Variable to define what type of data we are searching for
      searchSelector: "",

      // Collaborator search and addition variables
      chosenCollaboratorName: [],
      chosenCollaboratorType: [],
      resourceCollaborators: {},
      resourceCollaboratorsArray: [],

      // outputs search and addition variables
      chosenOutputsName: [],
      chosenOutputsArray: [],
      chosenOutputs: {},

      // Challenge search and addition variables
      chosenChallengeName: [],
      chosenChallengesArray: [],
      chosenChallenges: {},

      // Image search and addition variables
      chosenImageId: null,

      // Ingredients: Recipe search and addition variables
      chosenIngRecipeName: [],
      chosenIngRecipes: {},
      chosenIngRecipesArray: [],

      // Ingredients: Resource search and addition variables
      chosenIngResourceName: [],
      chosenIngResources: {},
      chosenIngResourcesArray: [],

      // Alert variables
      emptyTitleAlert: false,
      emptyDescriptionAlert: false,
      emptyImageResourceAlert: false,
      emptySelectedFocusAreas1Alert: false,
      emptyTargetTypeAlert: false,
      showDismissibleAlert: false,
      selectedFocusAreas: [], // Must be an array reference!
      selectedFocusAreas2: [], // Must be an array reference!
      additionalFocusArea: "",
      additionalTargetGroup: [],
      languages: [],
      countries: [],
      additionalLanguage: "",
      additionalCountry: "",
      FocusAreaOptions: [
        { text: "Arts and heritage", value: "Arts and heritage" },
        { text: "Community development", value: "Community development" },
        { text: "Education", value: "Education" },
        { text: "Human rights", value: "Human rights" },
        {
          text: "Intercultural understanding",
          value: "Intercultural understanding",
        },
        {
          text: "Interreligious understanding",
          value: "Interreligious understanding",
        },
        { text: "Job placement/employment", value: "Job placement/employment" },
        {
          text: "Leisure and entertainment",
          value: "Leisure and entertainment",
        },
        { text: "Skills development", value: "Skills development" },
        { text: "Social inclusion", value: "Social inclusion" },
        { text: "Other", value: "Other" },
      ],
      // FocusAreaOptions2: [
      //   {text: 'Job placement/employment', value: 'Job placement/employment'},
      //   {text: 'Leisure and entertainment', value: 'Leisure and entertainment'},
      //   {text: 'Skills development', value: 'Skills development'},
      //   {text: 'Social inclusion', value: 'Social inclusion'},
      //   {text: 'Other', value: 'Other'}],
      Duration: [
        { text: "", value: null },
        { text: "Short (1-6 months)", value: "Short (1-6 months)" },
        { text: "Medium (6-12 months)", value: "Medium (6-12 months)" },
        { text: "Long (1–3 years)", value: "(1–3 years)" },
        { text: "Very long (3+ years)", value: "Very long (3+ years)" },
      ],
      NumberOfParticipants: [
        { text: "", value: null },
        { text: "Small (under 10)", value: "Small (under 10)" },
        { text: "Medium (10-20)", value: "Medium (10-20)" },
        { text: "Large (20-50)", value: "Large (20-50)" },
        { text: "Very large (over 50)", value: "Very large (over 50)" },
      ],
      Cost: [
        { text: "", value: null },
        { text: "Basic expenses", value: "Basic expenses" },
        {
          text: "Small investment (e.g., organisation budget)",
          value: "Small investment (e.g., organisation budget)",
        },
        {
          text: "Medium investment (e.g., regional grant)",
          value: "Medium investment (e.g., regional grant)",
        },
        {
          text: "Large investment (e.g., national grant)",
          value: "Large investment (e.g., national grant)",
        },
        {
          text: "Very large investment (e.g., European grant)",
          value: "Very large investment (e.g., European grant)",
        },
      ],
      publicReadable: false,
      implemented: false,
      TargetGroupTypes: [
        // {text: 'Select target group type', value: ''},
        {
          text: "Disadvantaged or vulnerable groups",
          value: "Disadvantaged or vulnerable groups",
        },
        { text: "Elderly people", value: "Elderly people" },
        { text: "LGBTQI+", value: "LGBTQI+" },
        { text: "Migrants", value: "Migrants" },
        { text: "Minorities", value: "Minorities" },
        {
          text: "Refugees and asylum seekers",
          value: "Refugees and asylum seekers",
        },
        { text: "Unemployed", value: "Unemployed" },
        { text: "Women", value: "Women" },
        { text: "Youth", value: "Youth" },
        { text: "Other", value: "Other" },
      ],
      TargetGroupLanguage: [
        // {text: 'Select target group language', value: '', disabled: true},
        { text: "Arabic", value: "Arabic" },
        { text: "Chinese", value: "Chinese" },
        { text: "English", value: "English" },
        { text: "Finnish", value: "Finnish" },
        { text: "French", value: "French" },
        { text: "German", value: "German" },
        { text: "Greek", value: "Greek" },
        { text: "Italian", value: "Italian" },
        { text: "Spanish", value: "Spanish" },
        { text: "Other (specify)", value: "Other" },
      ],
      TargetGroupCountry: [
        // {text: 'Select target group country', value: '', disabled: true},
        { text: "Germany", value: "Germany" },
        { text: "Greece", value: "Greece" },
        { text: "Finland", value: "Finland" },
        { text: "Italy", value: "Italy" },
        { text: "Netherlands", value: "Netherlands" },
        { text: "Spain", value: "Spain" },
        { text: "United Kingdom", value: "United Kingdom" },
        { text: "Other (specify)", value: "Other" },
      ],
      // single values  Gen Info
      title: "",
      description: "",
      imageResource: 0,
      tips: "",
      // services: '',
      keywords: [],
      duration: "",
      cost: "",
      numberOfParticipants: "",
      challenges: [],
      steps: [{ title: "", description: "" }],
      collaboratorsWithId: [{ id: 0 }],
      recipes: [{ id: 0 }],
      resources: [{ id: 0 }],
      targetGroup: [{ type: "", description: "" }],
      outputs: [{ id: 0 }],
      url: "",
      collaborators: [
        {
          name: "",
          description: "",
          type: "",
        },
      ],
      challengesStepsWarning: false,
    };
  },
  components: {
    NoAccess,
    CreateNewResource,
    CreateNewOrganization,
  },
  watch: {
    chosenCollaboratorName: function () {
      return this.chosenCollaboratorName;
    },
  },
  beforeRouteLeave(to, from, next) {
    if (!this.saveAction && this.authenticatedUser) {
      this.boxOne = "";
      this.$bvModal
        .msgBoxConfirm(
          "Are you sure you want to leave without saving? If you do, all your work will be lost.",
          {
            title: "Warning",
            okVariant: "danger",
          }
        )
        .then((value) => {
          this.boxOne = value;
          if (this.boxOne) {
            next();
          } else {
            next(false);
          }
        });
      // .catch(error => {
      //   alert('An error occurred! Please refresh the page.' + error)
      // })
    } else {
      next();
    }
  },
  computed: {
    ...mapGetters(["authenticatedUser"]),
    FocusM() {
      let FocusM = this.selectedFocusAreas;
      return FocusM;
    },
    NewKeywordsArray() {
      let NewKeywordsArray = [];
      for (let i = 0; i < this.keywords.length; i++) {
        NewKeywordsArray.push(this.keywords[i].value);
      }
      return NewKeywordsArray;
    },
    IngredientsM() {
      let IngredientsM = [];
      for (let i = 0; i < this.recipes.length; i++) {
        // IngredientsM.push({recipe: this.recipes[i]})
        IngredientsM.push({ recipe: this.chosenIngRecipesArray[i] });
      }
      for (let i = 0; i < this.resources.length; i++) {
        // IngredientsM.push({resource: this.resources[i]})
        IngredientsM.push({ resource: this.chosenIngResourcesArray[i] });
      }
      return IngredientsM;
    },
    TargetGroupM() {
      let TargetGroupM = [];
      TargetGroupM = this.targetGroup;
      return TargetGroupM;
    },
    ImageResourceM() {
      let ImageResourceM = parseInt(this.imageResource, 10);
      return ImageResourceM;
    },
    ChallengesM() {
      let ChallengesM = [];
      for (let u = 0; u < this.challenges.length; u++) {
        // let resources = [{'id': this.chosenChallengesArray[u].id}]
        ChallengesM.push({
          description: this.challenges[u].description,
          solution: this.challenges[u].solution,
          // resources: resources
        });
      }
      return ChallengesM;
    },
  },
  beforeMount() {
    SearchPlugin.event.$on("updateterm", this.changeTerm);
    SearchPlugin.event.$on("showView", this.showView);
  },
  methods: {
    choseExisting() {
      // If the user has chosen an existing file after uploading a new one, clear the new one and keep the existing one
      this.chooseExisting = true;
      this.file = null;
    },
    choseNew() {
      // If the user has uploaded a file after choosing an existing file, clear the chosen one and keep the new one
      this.chooseExisting = false;
      this.chosenImageId = null;
    },
    searchOrganisation(index) {
      eventBus.$emit("forgetGlobalSearch", null);
      this.searchSelector = "searchedOrganisation";
      this.collaboratorPosition = index;
      this.searchCategory("Organisations");
    },
    searchOutputs(index) {
      eventBus.$emit("forgetGlobalSearch", null);
      this.searchSelector = "searchedOutputs";
      this.outputsPosition = index;
      this.searchTerm("", "Ingredients");
    },
    searchChallenge(index) {
      eventBus.$emit("forgetGlobalSearch", null);
      this.searchSelector = "searchedChallenge";
      this.challengePosition = index;
      this.searchTerm("", "Ingredients");
    },
    searchImage() {
      this.searchSelector = "searchedImage";
      this.searchTerm("", "Ingredients");
    },
    searchIngredientRecipe(index) {
      eventBus.$emit("forgetGlobalSearch", null);
      this.searchSelector = "searchedIngredientRecipe";
      this.ingRecipePosition = index;
      this.searchTerm("", "Recipes");
    },
    searchIngredientResource(index) {
      eventBus.$emit("forgetGlobalSearch", null);
      this.searchSelector = "searchedIngredientResource";
      this.ingResourcePosition = index;
      this.searchTerm("", "Ingredients");
    },
    checkForm() {
      this.emptyTitleAlert = false;
      this.emptyDescriptionAlert = false;
      this.emptyImageResourceAlert = false;
      this.emptySelectedFocusAreas1Alert = false;
      this.emptyTargetTypeAlert = false;
      this.showDismissibleAlert = false;

      if (
        this.selectedFocusAreas.includes("Other") &&
        this.FocusM[this.FocusM.length - 1] !== this.additionalFocusArea
      ) {
        this.FocusM.push(this.additionalFocusArea);
      }

      if (this.languages.includes("Other") && this.additionalLanguage) {
        this.languages.push(this.additionalLanguage);
      }

      if (this.countries.includes("Other") && this.additionalCountry) {
        this.countries.push(this.additionalCountry);
      }

      for (let i = 0; i < this.targetGroup.length; i++) {
        if (this.targetGroup[i].type.includes("Other")) {
          this.targetGroup[i].type.push(this.additionalTargetGroup[i]);
        }
        // if (this.targetGroup[i].language.includes('Other') && this.targetGroup[i].language[this.targetGroup[i].language.length - 1] !== this.additionalLanguage[i]) {
        //   this.targetGroup[i].language.push(this.additionalLanguage[i])
        // }
      }

      for (let i = 0; i < this.collaborators.length; i++) {
        if (!this.collaborators[i].name && !this.collaborators[i].description) {
          this.collaborators.splice(i, 1);
          i--;
        }
      }

      if (this.file) {
        // If the user has uploaded a file after choosing an existing file, clear the chosen one and keep the new one
        this.chosenImageId = null;
      }
      if (this.chosenImageId) {
        // If the user has chosen an existing file after uploading a new one, clear the new one and keep the existing one
        this.file = null;
      }
      // check if all required fields are filled
      if (
        !this.title ||
        !this.description ||
        this.selectedFocusAreas.length === 0
      ) {
        this.showDismissibleAlert = true;
        if (!this.title) {
          this.emptyTitleAlert = true;
        }
        if (!this.description) {
          this.emptyDescriptionAlert = true;
        }
        if (this.FocusM.length === 0) {
          this.emptySelectedFocusAreas1Alert = true;
        }
      } else {
        this.SendUserDataToAPI();
      }
    },
    deleteTargetGroup(index) {
      this.targetGroup.splice(index, 1);
    },
    deleteChallenge(index) {
      this.challenges.splice(index, 1);
      this.chosenChallengeName.splice(index, 1);
      this.challenges.splice(index, 1);
    },
    deleteStep(index) {
      this.steps.splice(index, 1);
    },
    addNewStepUnderneath(index) {
      this.steps.splice(index + 1, 0, { title: "", description: "" });
    },
    deleteCollaborator(index) {
      this.resourceCollaboratorsArray.splice(index, 1);
      this.chosenCollaboratorName.splice(index, 1);
      this.chosenCollaboratorType.splice(index, 1);
      this.collaboratorsWithId.splice(index, 1);
    },
    deleteNonExistingCollaborator(index) {
      this.collaborators.splice(index, 1);
    },
    deleteOutputs(index) {
      this.outputs.splice(index, 1);
      this.chosenOutputsArray.splice(index, 1);
      this.chosenOutputsName.splice(index, 1);
    },
    deleteRecipe(index) {
      this.recipes.splice(index, 1);
      this.chosenIngRecipesArray.splice(index, 1);
      this.chosenIngRecipeName.splice(index, 1);
    },
    deleteResource(index) {
      this.resources.splice(index, 1);
      this.chosenIngResourcesArray.splice(index, 1);
      this.chosenIngResourceName.splice(index, 1);
    },
    addNewCollaboratorForm() {
      this.collaboratorsWithId.push({});
    },
    addNewNonExistingCollaborator() {
      // this.collaborators.push({'type': 'GLAM (Galleries, Libraries, Archives, Museums)'})
      this.collaborators.push({ name: "", description: "", type: "" });
    },
    addNewOutputsForm() {
      this.outputs.push({});
    },
    addNewTargetGroupForm() {
      this.targetGroup.push({ type: "", description: "" });
    },
    addNewStepForm() {
      this.steps.push({ title: "", description: "" });
    },
    addNewRecipeForm() {
      this.recipes.push({ id: 0 });
    },
    addNewChallengeForm() {
      this.challenges.push({ description: "", solution: "", resources: "" });
    },
    addNewResourceForm() {
      this.resources.push({ id: 0 });
    },
    showMsgSuccess() {
      this.boxOne = "";
      this.$bvModal
        .msgBoxOk("Your recipe has been successfully created.", {
          okVariant: "success",
        })
        .then((value) => {
          this.boxOne = value;
          if (this.boxOne) {
            this.$router.push({ name: "recipes" });
          } else {
          }
        });
      // .catch(error => {
      //   alert('An error occurred! Please refresh the page.' + error)
      // })
    },
    showMsgFail() {
      this.boxOne = "";
      this.$bvModal
        .msgBoxOk("Something went wrong. Please try again.", {
          okVariant: "danger",
        })
        .then((value) => {
          this.boxOne = value;
          if (this.boxOne) {
            // window.location.reload()
          } else {
          }
        });
      // .catch(error => {
      //   alert('An error occurred! Please refresh the page.' + error)
      // })
    },
    showMsgChallengesSteps() {
      if (
        !this.challengesStepsWarning &&
        this.steps[0].title === "" &&
        this.ChallengesM.length < 1
      ) {
        this.boxOne = "";
        this.$bvModal
          .msgBoxConfirm(
            "You have not entered any Steps or Challenges for your Recipe. Are you sure you wish to proceed?",
            {
              okVariant: "info",
            }
          )
          .then((value) => {
            this.boxOne = value;
            if (this.boxOne) {
              this.challengesStepsWarning = true;
              this.registerRecipe();
            } else {
              this.contactWarning = true;
            }
          });
        // .catch(error => {
        //   alert('An error occurred! Please refresh the page.' + error)
        // })
      } else {
        this.registerRecipe();
      }
    },
    registerRecipe() {
      this.saveAction = true;
      let CompletedRecipeFormData = "";
      CompletedRecipeFormData = {
        title: this.title,
        description: this.description,
        imageResource: this.chosenImageId,
        metadataLanguage: "string",
        tips: this.tips,
        keywords: this.NewKeywordsArray,
        duration: this.duration,
        cost: this.cost,
        // services: this.services,
        numberOfParticipants: this.numberOfParticipants,
        outputs: this.chosenOutputsArray,
        publicReadable: this.publicReadable,
        implemented: this.implemented,
        areasOfFocus: this.FocusM,
        url: this.url,
        targetGroup: this.TargetGroupM,
        challenges: this.ChallengesM,
        steps: this.steps,
        collaboratorsWithId: this.resourceCollaboratorsArray,
        collaborators: this.collaborators,
        ingredients: this.IngredientsM,
        languages: this.languages,
        countries: this.countries,
      };
      if (!this.imageResource) {
        delete CompletedRecipeFormData.imageResource;
      }
      if (!this.tips) {
        delete CompletedRecipeFormData.tips;
      }
      if (this.steps.length === 0) {
        delete CompletedRecipeFormData.steps;
      }
      if (this.steps.length === 1) {
        if (this.steps[0].title === "" && this.steps[0].description === "") {
          delete CompletedRecipeFormData.steps;
        }
      }
      if (!this.keywords[0]) {
        delete CompletedRecipeFormData.keywords;
      }
      if (!this.challenges[0]) {
        delete CompletedRecipeFormData.challenges;
      }
      if (!this.duration) {
        delete CompletedRecipeFormData.duration;
      }
      if (!this.cost) {
        delete CompletedRecipeFormData.cost;
      }
      if (!this.numberOfParticipants) {
        delete CompletedRecipeFormData.numberOfParticipants;
      }
      if (this.FocusM.length === 0) {
        delete CompletedRecipeFormData.areasOfFocus;
      }
      if (this.IngredientsM.length === 0) {
        delete CompletedRecipeFormData.ingredients;
      }
      if (this.targetGroup.length === 0) {
        delete CompletedRecipeFormData.targetGroup;
      }
      if (this.targetGroup.length === 1) {
        if (this.targetGroup[0].type === "") {
          delete CompletedRecipeFormData.targetGroup;
        }
      }
      this.$store
        .dispatch("createRecipe", CompletedRecipeFormData)
        .then((recipe) => {
          if (recipe) {
            if (this.file !== null) {
              // console.log(recipe.data)
              let formData = new FormData();
              formData.append("file", this.file);
              let params = { id: recipe.id, file: formData };
              this.$store
                .dispatch("uploadRecipeBanner", params)
                .then((data) => {
                  this.showMsgSuccess();
                })
                .catch((error) => {
                  console.info(error);
                  this.showMsgFail();
                });
            } else {
              this.showMsgSuccess();
            }
          } else {
            this.showMsgFail();
          }
        })
        .catch((error) => {
          console.info(error);
          this.showMsgFail();
        });
    },
    SendUserDataToAPI() {
      if (this.targetGroup.length > 0) {
        let a = null;
        for (let i = 0; i < this.targetGroup.length; i++) {
          if (
            this.targetGroup[i].type === "" &&
            this.targetGroup[i].description !== ""
          ) {
            this.emptyTargetTypeAlert = true;
            window.alert(
              "You cannot create target without specifying its type"
            );
            // break
          } else a = a + 1;
        }

        if (this.targetGroup.length === a) {
          this.showMsgChallengesSteps();
        }
      }

      if (this.targetGroup.length === 0) {
        this.showMsgChallengesSteps();
      }
    },
    changeTerm(val) {
      this.sTerm = val;
    },
    showAll: function (token) {
      this.$search.searchNow();
    },
    showSearch: function () {
      this.$search.toggleSearch();
    },
    initOrg: function () {
      this.organisation = {};
    },
    initOutputs: function () {
      this.output = {};
    },
    initChallenge: function () {
      this.challenge = {};
    },
    initImage: function () {
      this.image = {};
    },
    initIngRecipe: function () {
      this.ingRecipe = {};
    },
    initIngResource: function () {
      this.ingResource = {};
    },
    showView: function (event) {
      if (this.searchSelector === "searchedOrganisation") {
        this.$store
          .dispatch("getOrganizationEntity", event.detail.id)
          .then((data) => {
            this.initOrg();
            this.organisation = data;
            if (
              this.resourceCollaboratorsArray[this.collaboratorPosition] == null
            ) {
              this.chosenCollaboratorName.push(this.organisation.name);
              this.chosenCollaboratorType.push(this.organisation.type);
              this.resourceCollaborators["id"] = event.detail.id;
              this.resourceCollaboratorsArray.push(this.resourceCollaborators);
              this.resourceCollaborators = {};
            } else {
              this.resourceCollaboratorsArray.splice(
                this.collaboratorPosition,
                1
              );
              this.chosenCollaboratorName.splice(
                this.collaboratorPosition,
                1,
                this.organisation.name
              );
              this.chosenCollaboratorType.splice(
                this.collaboratorPosition,
                1,
                this.organisation.type
              );
              this.resourceCollaborators["id"] = event.detail.id;
              this.resourceCollaboratorsArray.push(this.resourceCollaborators);
              this.resourceCollaborators = {};
            }
          })
          .catch((error) => {
            console.info(error);
          });
      } else if (this.searchSelector === "searchedOutputs") {
        this.$store
          .dispatch("getResourceEntity", event.detail.id)
          .then((response) => {
            this.initOutputs();
            this.output = response;
            if (this.chosenOutputsArray[this.outputsPosition] == null) {
              this.chosenOutputsName.push(this.output.title);
              this.chosenOutputs["id"] = event.detail.id;
              this.chosenOutputsArray.push(this.chosenOutputs);
              this.chosenOutputs = {};
            } else {
              this.chosenOutputsArray.splice(this.outputsPosition, 1);
              this.chosenOutputsName.splice(
                this.outputsPosition,
                1,
                this.output.title
              );
              this.chosenOutputs["id"] = event.detail.id;
              this.chosenOutputsArray.push(this.chosenOutputs);
              this.chosenOutputs = {};
            }
          })
          .catch((error) => {
            console.info(error);
          });
      } else if (this.searchSelector === "searchedChallenge") {
        this.$store
          .dispatch("getResourceEntity", event.detail.id)
          .then((response) => {
            this.initChallenge();
            this.challenge = response;
            if (this.chosenChallengesArray[this.challengePosition] == null) {
              this.chosenChallengeName.push(this.challenge.title);
              this.chosenChallengesArray.push(event.detail.id);
              this.chosenChallenges = {};
            } else {
              this.chosenChallengeName.splice(
                this.challengePosition,
                1,
                this.challenge.title
              );
              this.chosenChallengesArray.splice(
                this.challengePosition,
                1,
                response
              );
              this.chosenChallenges = {};
            }
          })
          .catch((error) => {
            console.info(error);
          });
      } else if (this.searchSelector === "searchedImage") {
        this.chosenImageId = event.detail.id;
      } else if (this.searchSelector === "searchedIngredientRecipe") {
        this.$store
          .dispatch("getRecipeEntity", event.detail.id)
          .then((data) => {
            this.initIngRecipe();
            this.ingRecipe = data;
            if (this.chosenIngRecipesArray[this.ingRecipePosition] == null) {
              this.chosenIngRecipeName.push(this.ingRecipe.title);
              this.chosenIngRecipes["id"] = event.detail.id;
              this.chosenIngRecipesArray.push(this.chosenIngRecipes);
              this.chosenIngRecipes = {};
            } else {
              this.chosenIngRecipesArray.splice(this.ingRecipePosition, 1);
              this.chosenIngRecipeName.splice(
                this.ingRecipePosition,
                1,
                this.ingRecipe.title
              );
              this.chosenIngRecipes["id"] = event.detail.id;
              this.chosenIngRecipesArray.push(this.chosenIngRecipes);
              this.chosenIngRecipes = {};
            }
          })
          .catch((error) => {
            console.info(error);
          });
      } else if (this.searchSelector === "searchedIngredientResource") {
        this.$store
          .dispatch("getResourceEntity", event.detail.id)
          .then((response) => {
            this.initIngResource();
            this.ingResource = response;
            if (
              this.chosenIngResourcesArray[this.ingResourcePosition] == null
            ) {
              this.chosenIngResourceName.push(this.ingResource.title);
              this.chosenIngResources["id"] = event.detail.id;
              this.chosenIngResourcesArray.push(this.chosenIngResources);
              this.chosenIngResources = {};
            } else {
              this.chosenIngResourcesArray.splice(this.challengePosition, 1);
              this.chosenIngResourceName.splice(
                this.challengePosition,
                1,
                this.ingResource.title
              );
              this.chosenIngResources["id"] = event.detail.id;
              this.chosenIngResourcesArray.push(this.chosenIngResources);
              this.chosenIngResources = {};
            }
          })
          .catch((error) => {
            console.info(error);
          });
      }
    },
    searchCategory: function (cat_type, token) {
      this.$search.searchNow({
        resulttype: cat_type,
        token: token,
      });
    },
    searchTerm: function (term, resulttype, token) {
      this.$search.searchNow({
        term: term,
        resulttype: resulttype,
        token: token,
      });
    },
  },
  created() {
    eventBus.$on("hideModal", (data) => {
      this.modalResShow = data;
    });
    eventBus.$on("resourceTitle", (resourceTitle) => {
      this.chosenIngResourceName.push(resourceTitle);
    });
    eventBus.$on("resourceId", (resourceId) => {
      this.chosenIngResources["id"] = resourceId;
      this.chosenIngResourcesArray.push(this.chosenIngResources);
      this.chosenIngResources = {};
    });
    eventBus.$on("hideOrgModal", (hideOrgModal) => {
      this.modalOrgShow = hideOrgModal;
    });
    eventBus.$on("organizationTitle", (organizationTitle) => {
      this.chosenCollaboratorName.push(organizationTitle);
    });
    eventBus.$on("organizationId", (organizationId) => {
      this.resourceCollaborators["id"] = organizationId;
      this.resourceCollaboratorsArray.push(this.resourceCollaborators);
      this.resourceCollaborators = {};
    });
  },
};
</script>

<style scoped>
.textareaDescription {
  height: 125px;
}

.height2 {
  height: 70px;
}
</style>

<style>
.custom-control {
  float: left;
  width: 100%;
}

.widthTextAreaOutputs {
  width: 450px;
  margin-left: 10px;
}

.CollaboratorsAlign {
  width: 280px;
  margin-left: 20px;
}

.CollaboratorsAlign2 {
  width: 280px;
  margin-left: 30px;
}
</style>



// WEBPACK FOOTER //
// src/views/RecipeAdd.vue